// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BankResponseAPIModel,
    BankResponseAPIModelFromJSON,
    BankResponseAPIModelFromJSONTyped,
    BankResponseAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BanksResponseAPIModel
 */
export interface BanksResponseAPIModel {
    /**
     * 
     * @type {Array<BankResponseAPIModel>}
     * @memberof BanksResponseAPIModel
     */
    banks: Array<BankResponseAPIModel>;
}

export function BanksResponseAPIModelFromJSON(json: any): BanksResponseAPIModel {
    return BanksResponseAPIModelFromJSONTyped(json, false);
}

export function BanksResponseAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BanksResponseAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'banks': ((json['banks'] as Array<any>).map(BankResponseAPIModelFromJSON)),
    };
}

export function BanksResponseAPIModelToJSON(value?: BanksResponseAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'banks': ((value.banks as Array<any>).map(BankResponseAPIModelToJSON)),
    };
}


